export default "__VITE_ASSET__63208c2a__"